import {IntegrationHistoryFormProps} from "../../integrations/history/IntegrationHistoryForm";
import {Button, Field, FieldsContainer, GridModalFormProps, PageHeader, Spacer, TextField} from "../../../../common";
import {OrderListItem} from "./orderListApi";
import {Box, Card, CardContent, DialogActions, DialogContent, Grid, Typography} from "@mui/material";
import I18n from "i18n-js";
import React from "react";

export interface OrderViewProps extends GridModalFormProps {
  listItem?: OrderListItem | any;
}

export default function OrderView({
                                    id,
                                    afterSave,
                                    onClose,
                                    listItem,
                                  }: OrderViewProps) {

  if (!listItem) {
    return (<></>);
  }

  return (
    <>
      <PageHeader title={I18n.t("MyAccount.pages.billingAndPlans.order.order")} onClose={onClose}/>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Typography variant={"h5"} sx={{mb: 1}}>
              Billing Plan
            </Typography>
            <Typography variant={"h4"} sx={{color: 'text.secondary'}}>
              {listItem.bundle_name}
            </Typography>
            <Typography variant={"body1"} sx={{color: 'text.secondary'}}>
              {listItem.bundle_type}
            </Typography>
            <Spacer h={1}/>
            <Box>
              <Typography variant="body1" color="text.secondary">
                - {I18n.t("MyAccount.pages.order.limits.userLimit", {
                userLimit: 10,
              })}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                - {I18n.t("MyAccount.pages.order.limits.waiverLimit", {
                waiverLimit: 10,
              })}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                - {I18n.t("MyAccount.pages.order.limits.storageLimit", {
                storageLimit: 10,
              })}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                - {I18n.t("MyAccount.pages.order.limits.submitLimit", {
                submitLimit: 10,
              })}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                - {I18n.t("MyAccount.pages.order.limits.locationLimit", {
                locationLimit: 10,
              })}
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <FieldsContainer>
                  <Field fullWidth>
                    <TextField disabled value={listItem.first_name} label={"First Name"}/>
                  </Field>
                  <Field fullWidth>
                    <TextField disabled value={listItem.last_name} label={"Last Name"}/>
                  </Field>
                  <Field fullWidth>
                    <TextField disabled value={listItem.street} label={"Street"}/>
                  </Field>
                  <Field fullWidth>
                    <TextField disabled value={listItem.city} label={"City"}/>
                  </Field>
                  <Field fullWidth>
                    <TextField disabled value={listItem.country} label={"Country"}/>
                  </Field>
                  <Field fullWidth>
                    <TextField disabled value={listItem.zip} label={"zip"}/>
                  </Field>
                  <Field fullWidth>
                    <TextField disabled value={listItem.phone} label={"Phone"}/>
                  </Field>
                </FieldsContainer>
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <FieldsContainer>
                  <Field fullWidth>
                    <TextField disabled value={listItem.price} label={"Price"}/>
                  </Field>
                  <Field fullWidth>
                    <TextField disabled value={listItem.created_at} label={"Date"}/>
                  </Field>
                </FieldsContainer>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("App.close")}
          onClick={() => onClose && onClose()}
        />
      </DialogActions>
    </>
  );
}